/**
 * File qsp-helpers.js.
 * Helpful functions for QSP related logic
 */

// remove param from array if exists
function removeParam(paramsArray, paramToRemove) {
  if (typeof(paramsArray.has) == 'function' ) {
    if(paramsArray.has(paramToRemove)) {
      paramsArray.delete(paramToRemove);
    }
  } else {
    let removeIndex = paramsArray.indexOf(paramToRemove);
    while (removeIndex > -1) {
      paramsArray.splice(removeIndex, 1);
      removeIndex = paramsArray.indexOf(paramToRemove);
    }
  }
}

// remove exact duplicate params and join
function getDistinctQueryString(paramsArray) {
  var distinctParamsSet = [...new Set(paramsArray)];
  return distinctParamsSet.join('&');
}

function getSearchList(token, pageId) {
  const tokenQSPs = (token) ? ['ad', 'ch_' + pageId + 'id'] : [];
  let searchList = [];

  if (globalSearchParams.toString()) {
    for(var key of globalSearchParams.keys()) {
      if (tokenQSPs.indexOf(key) == -1){
        searchList.push(key);
      }
    }
  }
  
  return searchList;
}

function getParamsArray(searchList) {
  let paramsArray = [];

  for (const [key, value] of globalSearchParams.entries()) {
    if (searchList.indexOf(key) > -1) {
      paramsArray.push(`${key}=${value}`);
    }
  }

  return paramsArray;
}

function addTokenQSPs(paramsArray, token, pageId) {
  if (!token) return;
  paramsArray.push('ad=ch_' + pageId, 'ch_' + pageId + 'id=' + token);
}